import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import TextLink from '@toasttab/shared/src/components/TextLink/TextLink'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'
import { anchorLinkScroll } from '@toasttab/shared/src/utils/linkUtils'
import { DataArticleTableOfContentsProps } from './DataArticle.d'

const DataArticleTableOfContents = ({
  activeSection,
  links
}: DataArticleTableOfContentsProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [width, setWidth] = useState<number>(0)

  const handleOpen = () => {
    setIsOpen(!isOpen)
  }

  const handleClick = (e: any) => {
    const target = e.currentTarget.getAttribute('data-href')
    if (target) {
      anchorLinkScroll(`#${target}`)
    }
  }

  function handleWindowSizeChange() {
    setWidth(window.innerWidth)
  }
  const isMobileLayout = width < 1024

  useEffect(() => {
    if (typeof window !== 'undefined') {
      handleWindowSizeChange()
      window.addEventListener('resize', handleWindowSizeChange)
      return () => {
        window.removeEventListener('resize', handleWindowSizeChange)
      }
    }
  }, [])

  const ButtonEl = isMobileLayout ? 'button' : 'div'
  const iconClasses = classNames('inline-block transition-all lg:hidden', {
    'rotate-180': isOpen
  })
  const linkContainerClasses = classNames('transition-all overflow-hidden', {
    'max-h-screen': isOpen || !isMobileLayout,
    'max-h-0': !isOpen && isMobileLayout
  })

  return (
    <>
      <ButtonEl
        data-testid='DataArticleTableOfContents-heading'
        onClick={isMobileLayout ? handleOpen : null}
      >
        <h5 className='!font-calibre !font-medium !text-[22px] after:content-icon-chevron-down lg:after:content-none'>
          In this article{' '}
          <img
            alt='expand'
            className={iconClasses}
            src={resolvePrefix('/svg/icon-expand-more.svg')}
          />
        </h5>
      </ButtonEl>
      <div
        className={linkContainerClasses}
        data-testid='DataArticleTableOfContents-links'
      >
        {links?.length > 0 && (
          <ul className='mt-3'>
            {links.map((link) => {
              const linkClasses = classNames('block p-2 w-full text-left', {
                'hover:text-blue-75':
                  link.anchor !== activeSection || isMobileLayout,
                'bg-gray-0 rounded-lg':
                  link.anchor === activeSection && !isMobileLayout
              })
              return (
                <li className='mb-2' key={link.anchor}>
                  <button
                    className={linkClasses}
                    data-href={link.anchor}
                    onClick={handleClick}
                  >
                    {link.heading}
                  </button>
                </li>
              )
            })}
          </ul>
        )}
        <div className='mt-6'>
          <p className='font-semibold text-base font-sansPro'>
            Become a Toast Subject Matter Expert today
          </p>
          <TextLink
            href='mailto:ontheline@toasttab.com'
            icon='arrowRight'
            text='Get featured'
          />
        </div>
      </div>
    </>
  )
}

export default DataArticleTableOfContents
